exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-large-body {\n  min-height: 480px;\n}\n.expense-mobile-icon-list {\n  padding: 0 !important;\n}\n.expense-mobile-icon-list .label {\n  font-size: 0.8rem;\n  line-height: 1.1;\n}\n.my-expense-mobile-view-component-wrapper {\n  margin-top: 1.5rem;\n}\n.btn-custom {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  position: sticky;\n  width: 100%;\n  bottom: 0;\n  z-index: 999;\n  padding: 10px;\n}\n#table-clickable tbody tr {\n  cursor: pointer;\n}\n#dropdown-options button:nth-child(1) {\n  width: 80% !important;\n}\n", ""]);

// exports
